import type React from 'react';

interface DividerProps {
  className?: string;
  variant?: 'default' | 'gradient' | 'gradient-blur';
}

const Divider: React.FC<DividerProps> = ({
  className = '',
  variant = 'default',
}) => {
  const renderDivider = () => {
    switch (variant) {
      case 'gradient':
        return (
          <div className='relative h-1 w-full'>
            <div className='absolute inset-0 animate-gradient-x bg-gradient-to-r from-transparent via-blue-400 to-transparent' />
          </div>
        );

      case 'gradient-blur':
        return (
          <div className='-my-6 pointer-events-none relative z-10 h-12 w-full'>
            <div className='absolute inset-0 bg-gray-900/5 backdrop-blur-xl [mask-image:linear-gradient(to_bottom,transparent,black_15%,black_85%,transparent)]' />
            <div className='absolute inset-0 border-gray-700/5 border-y [mask-image:linear-gradient(to_bottom,transparent,black_15%,black_85%,transparent)]' />
          </div>
        );

      default:
        return (
          <div className='relative h-1 w-full'>
            <div className='absolute inset-0 animate-gradient-x bg-gradient-to-r from-transparent via-blue-400 to-transparent' />
          </div>
        );
    }
  };

  return <div className={`${className}`}>{renderDivider()}</div>;
};

export default Divider;
